import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconProfilePencil: React.FC<IconProps> = ({ width = 20, height = 20, color = '#23262A' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.332 6.66797C14.6581 6.66797 15.9299 7.19475 16.8676 8.13243C17.8052 9.07012 18.332 10.3419 18.332 11.668V17.5013H14.9987V11.668C14.9987 11.2259 14.8231 10.802 14.5105 10.4895C14.198 10.1769 13.7741 10.0013 13.332 10.0013C12.89 10.0013 12.4661 10.1769 12.1535 10.4895C11.841 10.802 11.6654 11.2259 11.6654 11.668V17.5013H8.33203V11.668C8.33203 10.3419 8.85882 9.07012 9.7965 8.13243C10.7342 7.19475 12.0059 6.66797 13.332 6.66797Z"
                fill={color}
            />
            <path d="M5.0013 7.5H1.66797V17.5H5.0013V7.5Z" fill={color} />
            <path
                d="M3.33464 5.0013C4.25511 5.0013 5.0013 4.25511 5.0013 3.33464C5.0013 2.41416 4.25511 1.66797 3.33464 1.66797C2.41416 1.66797 1.66797 2.41416 1.66797 3.33464C1.66797 4.25511 2.41416 5.0013 3.33464 5.0013Z"
                fill={color}
            />
        </svg>
    );
};

export default IconProfilePencil;
